import { render, staticRenderFns } from "./Nutrition.vue?vue&type=template&id=adc2ff8a&"
import script from "./Nutrition.vue?vue&type=script&lang=js&"
export * from "./Nutrition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports